function responsiveTable() {
  $('.responsive-table').each(function () {
    const $table = $(this);
    const $headers = $table.find('tbody tr:first-child td');

    $table
      .find('tbody tr')
      .not(':first-child')
      .each(function () {
        $(this)
          .find('td')
          .each(function (index) {
            $(this).attr('data-label', $headers.eq(index).text());
          });
      });
  });

  function removeInlineStyles() {
    $('.responsive-table').find('*').each(function () {
      const currentStyle = $(this).attr('style');
      if (currentStyle) {
        const styles = currentStyle.split(';').filter(style => {
          return style.trim().startsWith('text-decoration') && style.includes('underline');
        }).join('; ');
        if (styles) {
          $(this).attr('style', styles);
        } else {
          $(this).removeAttr('style');
        }
      }
    });
  }

  if ($(window).width() <= 768) {
    removeInlineStyles();
  }

  $(window).on('resize', function () {
    if ($(window).width() <= 768) {
      removeInlineStyles();
    }
  });
}

export default responsiveTable;
